import dayjs from 'dayjs';
import { Progress, theme } from 'antd';
import { ExclamationCircleFilled, WarningFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStage } from '../../Provider';
import { useStores } from '@/hooks/use-stores';
import { useCallback } from 'react';

export const DueDateProgress = observer(() => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const {
    lifecycleStore: {
      activeStageTimer: { timerString, isWithin24Hours, isPeriodPassed },
    },
  } = useStores();
  const { isCurrent, expectedDuration, startTime } = useStage();

  const calculatePeriodPassedPercentage = useCallback((startDate: dayjs.Dayjs, endDate: dayjs.Dayjs) => {
    const now = dayjs();
    const timePassed = now.diff(startDate);
    const timePassedPercentage = (timePassed / endDate.diff(startDate)) * 100;
    return timePassedPercentage;
  }, []);

  const createdAtDate = dayjs(startTime);
  const dueDate = createdAtDate.add(expectedDuration, 'days');

  const progressColor =
    isPeriodPassed || isWithin24Hours
      ? {
          '0%': token.colorSuccess,
          '50%': token.colorWarning,
          '100%': token.colorError,
        }
      : token.colorSuccess;

  const TimerIcon = isPeriodPassed ? WarningFilled : isWithin24Hours ? ExclamationCircleFilled : null;

  return (
    <div className="due-date-progress-section">
      <div className="due-date-label-container">
        <div className="due-date-label">{t('Time left to complete')}</div>
        <div className="timer-container">
          {isCurrent && TimerIcon && (
            <TimerIcon className={`timer-icon ${isPeriodPassed ? 'timer-icon-passed' : ''}`} />
          )}
          <div className="timer-value">{isCurrent && timerString ? timerString : '--:--:--'}</div>
        </div>
      </div>
      <div className="due-date-progress-container">
        <span>{isCurrent ? createdAtDate.format('MMM DD, YYYY') : 'MM DD, YYYY'}</span>
        <Progress
          percent={isCurrent && timerString ? calculatePeriodPassedPercentage(createdAtDate, dueDate) : 0}
          strokeColor={progressColor}
          showInfo={false}
          strokeWidth={8}
        />
        <span>{isCurrent ? (expectedDuration ? dueDate.format('MMM DD, YYYY') : '--') : 'MM DD, YYYY'}</span>
      </div>
    </div>
  );
});
